import { createSlice } from "@reduxjs/toolkit";

export const LoanSlice = createSlice({
    name: "loanSlice",
    initialState: {
        allLender: [],
        allBorrower: [],
    },
    reducers: {
        getAllLenderReducer: (state, action) => {
            state.allLender = action.payload
        },
        getAllBorrowerReducer: (state, action) => {
            state.allBorrower = action.payload
        }
    }
})